(function () {
    if (window.__headerPageSliderBound) return;
    window.__headerPageSliderBound = true;

    function mountHeaderPageSliders(root) {
        if (typeof Swiper === 'undefined') return;
        root.querySelectorAll('[data-hp-slider-images]').forEach(function (slider) {
            var el = slider.querySelector('.hp-slider-images-swiper');
            if (!el) return;
            if (el.swiper) el.swiper.destroy(true, true);

            new Swiper(el, {
                slidesPerView: 1,
                loop: false,
                speed: 450,
                spaceBetween: 0,
                pagination: {
                    el: slider.querySelector('.hp-slider-images-pagination'),
                    clickable: true,
                },
            });
        });
    }

    function boot() {
        mountHeaderPageSliders(document);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
        var root = document.getElementById('shopify-section-' + e.detail.sectionId);
        if (!root) return;
        mountHeaderPageSliders(root);
    });
})();
